import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  id: "tags-view-container",
  class: "tags-view-container"
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
import { nextTick } from 'vue';
import EventBus from '@/utils/event-bus';
import useStore from '@/store';
import { EVENT } from '@/constant/event';
import path from 'path-browserify';
import ScrollPane from './ScrollPane.vue';

import { useRouter, useRoute } from 'vue-router';
import { computed, ref, onMounted, watch } from 'vue';
// const generateTitle = generateTitle
export default /*@__PURE__*/_defineComponent({
  __name: 'TagsView',
  setup(__props) {
    const tagsView = useStore().tagsView;
    const permission = useStore().permission;
    const router = useRouter();
    const route = useRoute();
    const visitedViews = computed(() => tagsView.visitedViews);
    const routes = computed(() => permission.routes);
    const scrollPaneRef = ref();
    const affixTags = ref([]);
    const visible = ref(false);
    const selectedTag = ref();
    const left = ref(0);
    const top = ref(0);
    onMounted(() => {
      initTags();
      if (route.path !== '/home') {
        addTags();
        moveToCurrentTag();
      }
      EventBus.on(EVENT.REFRESH_ACTIVE_VIEW, () => {
        const views = visitedViews.value;
        if (!views) {
          return;
        }
        const active = views.find(v => isActive(v));
        if (active) {
          refreshSelectedTag(active);
        }
      });
      scrollPaneRef.value?.moveToTarget({
        path: '17',
        title: ''
      });
    });
    watch(visible, value => {
      if (value) {
        document.body.addEventListener('click', closeMenu);
      } else {
        document.body.removeEventListener('click', closeMenu);
      }
    });
    watch(route, () => {
      addTags();
      moveToCurrentTag();
    });
    function filterAffixTags(routes, basePath = '/') {
      // eslint-disable-next-line no-undef
      let tags = [];
      routes.forEach(route => {
        if (route.meta && route.meta.affix) {
          const tagPath = path.resolve(basePath, route.path);
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: {
              ...route.meta
            }
          });
        }
        if (route.children) {
          const childTags = filterAffixTags(route.children, route.path);
          if (childTags.length >= 1) {
            tags = tags.concat(childTags);
          }
        }
      });
      return tags;
    }
    function initTags() {
      const res = filterAffixTags(routes.value);
      affixTags.value = res;
      for (const tag of res) {
        if (tag.name) {
          tagsView.addVisitedView(tag);
        }
      }
    }
    function addTags() {
      if (route.name) {
        // eslint-disable-next-line no-undef
        tagsView.addView(route);
      }
    }
    function moveToCurrentTag() {
      nextTick(() => {
        for (const r of visitedViews.value) {
          if (r.path === route.path) {
            scrollPaneRef.value?.moveToTarget(r);
            // when query is different then update
            if (r.fullPath !== route.fullPath) {
              tagsView.updateVisitedView(route);
            }
          }
        }
      });
    }
    function closeOthersTags() {
      router.push(selectedTag.value);
      tagsView.delOthersViews(selectedTag.value).then(() => {
        moveToCurrentTag();
      });
    }
    function isActive(tag) {
      return tag.path === route.path;
    }
    function isAffix(tag) {
      return tag && tag.meta && tag.meta.affix;
    }
    function refreshSelectedTag(view) {
      tagsView.delCachedView(view);
      const {
        fullPath
      } = view;
      nextTick(() => {
        router.replace({
          path: '/redirect' + fullPath,
          query: queryStringToObj()
        }).catch(err => {
          console.warn(err);
        });
      });
    }
    function queryStringToObj() {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      const obj = {};
      for (let [key, value] of params.entries()) {
        obj[key] = value;
      }
      return obj;
    }
    function toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0];
      if (latestView && latestView.fullPath) {
        router.push(latestView.fullPath);
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === 'Dashboard') {
          // to reload home page
          router.replace({
            path: '/redirect' + view.fullPath
          });
        } else {
          router.push('/');
        }
      }
    }
    function closeSelectedTag(view) {
      tagsView.delView(view).then(res => {
        if (isActive(view)) {
          toLastView(res.visitedViews, view);
        }
      });
    }
    function closeAllTags(view) {
      tagsView.delAllViews().then(res => {
        toLastView(res.visitedViews, view);
      });
    }
    function openMenu(tag, e) {
      // const menuMinWidth = 105;
      // // const offsetLeft = proxy?.$el.getBoundingClientRect().left; // container margin left
      // // const offsetWidth = proxy?.$el.offsetWidth; // container width
      // const offsetLeft = 0
      // const offsetWidth = 0
      // const maxLeft = offsetWidth - menuMinWidth; // left boundary
      // const l = e.clientX - offsetLeft + 15; // 15: margin right
      // if (l > maxLeft) {
      //   left.value = maxLeft;
      // } else {
      //   left.value = l;
      // }
      left.value = e.clientX;
      top.value = e.clientY;
      visible.value = true;
      selectedTag.value = tag;
    }
    function closeMenu() {
      visible.value = false;
    }
    function handleScroll() {
      closeMenu();
    }
    return (_ctx, _cache) => {
      const _component_x_icon = _resolveComponent("x-icon");
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(ScrollPane, {
        ref_key: "scrollPaneRef",
        ref: scrollPaneRef,
        class: "tags-view-wrapper",
        onScroll: handleScroll
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visitedViews), tag => {
          return _openBlock(), _createBlock(_component_router_link, {
            ref_for: true,
            ref: "tag",
            key: tag.path,
            class: _normalizeClass([isActive(tag) ? 'active' : '', "tags-view-item"]),
            to: {
              path: tag.path,
              query: tag.query,
              fullPath: tag.fullPath
            },
            onMouseup: _withModifiers($event => !isAffix(tag) ? closeSelectedTag(tag) : '', ["middle"]),
            onContextmenu: _withModifiers($event => openMenu(tag, $event), ["prevent"])
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createTextVNode(_toDisplayString(tag.title) + " ", 1), !isAffix(tag) ? (_openBlock(), _createBlock(_component_x_icon, {
              key: 0,
              style: {
                "margin-left": "4px"
              },
              icon: "el-icon-close",
              onClick: _withModifiers($event => closeSelectedTag(tag), ["prevent", "stop"])
            }, null, 8, ["onClick"])) : _createCommentVNode("", true)])]),
            _: 2
          }, 1032, ["class", "to", "onMouseup", "onContextmenu"]);
        }), 128))]),
        _: 1
      }, 512), _withDirectives(_createElementVNode("ul", {
        style: _normalizeStyle({
          left: _unref(left) + 'px',
          top: _unref(top) + 'px'
        }),
        class: "contextmenu"
      }, [_createElementVNode("li", {
        onClick: _cache[0] || (_cache[0] = $event => refreshSelectedTag(_unref(selectedTag)))
      }, "刷新"), !isAffix(_unref(selectedTag)) ? (_openBlock(), _createElementBlock("li", {
        key: 0,
        onClick: _cache[1] || (_cache[1] = $event => closeSelectedTag(_unref(selectedTag)))
      }, "关闭")) : _createCommentVNode("", true), _createElementVNode("li", {
        onClick: closeOthersTags
      }, "关闭其他"), _createElementVNode("li", {
        onClick: _cache[2] || (_cache[2] = $event => closeAllTags(_unref(selectedTag)))
      }, "关闭所有")], 4), [[_vShow, _unref(visible)]])]);
    };
  }
});